<form
	[formGroup]="locationForm"
	class="flex-layout column flex-layout justify-space-between"
>
	<div class="border-class">
		<div class="header-text">
			<h3>{{ 'edit_location_data' | translate }}</h3>
			<p class="address-text">
				{{ 'address' | translate }}: {{ address?.city }}, {{ address?.street }},
				{{ address?.number }}
			</p>
			<p class="create-building-text">{{ 'create_building_msg' | translate }}</p>
		</div>
		<div class="name-section">
			<div class="form-label">
				<mat-label>{{ 'location_name' | translate }}*</mat-label>
			</div>
			<mat-form-field hideRequiredMarker class="field wide-field">
				<input
					formControlName="name"
					type="text"
					matInput
					[maxlength]="50"
					[placeholder]="'location_name' | translate"
				/>
				<mat-hint>
					<span>*{{ 'required' | translate }}</span>
				</mat-hint>
			</mat-form-field>
		</div>
		<div class="location-fields">
			<div class="form-label-and-input">
				<label>{{ 'building_square_meters' | translate }}</label>
				<mat-form-field hideRequiredMarker class="field">
					<input
						#inputElement
						formControlName="squareMeters"
						matInput
						[placeholder]="'enter_building_square_meters' | translate"
						type="number"
						min="1"
						(keydown.enter)="$event.preventDefault()"
						[required]="false"
					/>
					<mat-error>
						@if (locationForm.controls.squareMeters?.hasError('pattern')) {
							{{ 'invalid' | translate }}
						}
					</mat-error>
				</mat-form-field>
			</div>
			<div class="form-tabel-and-input">
				<mat-label>{{ 'construction_year' | translate }}</mat-label>
				<mat-form-field>
					<input
						#inputElement
						formControlName="constructionYear"
						(input)="onInput($event)"
						matInput
						type="number"
						(keypress)="limitYearInput($event)"
						[placeholder]="'year_hint' | translate"
						[matAutocomplete]="autoYears"
						(keydown.enter)="$event.preventDefault()"
						[required]="false"
					/>
					<mat-icon svgIcon="arrow_dropdown" matSuffix></mat-icon>
					<mat-autocomplete
						class="nice-scroll colored-scroll-track visible-scroll"
						#autoYears="matAutocomplete"
					>
						@for (year of filteredYears(); track year) {
							<mat-option [value]="year">{{ year }}</mat-option>
						}
					</mat-autocomplete>
					<mat-hint align="start">
						<span>{{ 'year_hint' | translate }}</span>
					</mat-hint>
				</mat-form-field>
			</div>
		</div>
		<div class="form-label">
			<label>{{ 'building_type' | translate }}</label>
		</div>
		<mat-button-toggle-group class="building-type" formControlName="facilityType">
			<mat-button-toggle value="MANAGEMENT">{{
				'management' | translate
			}}</mat-button-toggle>
			<mat-button-toggle value="PROJECT">{{ 'project' | translate }}</mat-button-toggle>
		</mat-button-toggle-group>
	</div>
	<div class="buttons-container">
		<button mat-button [mat-dialog-close]="null">
			{{ 'cancel' | translate }}
		</button>
		<button
			mat-flat-button
			[disabled]="isInvalidForm() || isSavingProcess"
			[mat-dialog-close]="saveChanges()"
			type="submit"
			form="newBuildingForm"
		>
			{{ 'save' | translate }}
		</button>
	</div>
</form>
